import { companyInDtoToEntity } from 'serviceWorker/repository/company/mapping';
import { CompanyModel } from 'shared/domain/company/types/model';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { CompanyInDto } from 'shared/dtos/in/company';
import { companyEntityToModel } from 'serviceWorker/repository/company/mapping';
import { getUsersSynchronized } from 'serviceWorker/services/users/getUsers';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import * as dbCompanies from '../../db/companies/companies';
import { broadcastUploadedCompanyError } from './error';
import { companyContract } from 'shared/domain/company/companyContract';
import { makeEventPublisher } from 'serviceWorker/broadcasts/publishers';
import { scopeOfProject } from 'serviceWorker/helpers/dataScope';

export const broadcastUploadedCompany = makeEventPublisher(companyContract, DomainMessagesTypes.uploadedEntity);

export const broadcastDeletedCompany = makeEventPublisher(companyContract, DomainMessagesTypes.deletedEntity);

export const broadcastUpdatedCompany = makeEventPublisher(companyContract, DomainMessagesTypes.updatedEntity);

const broadcastCreatedCompanyModel = makeEventPublisher(companyContract, DomainMessagesTypes.createdEntity);

/** Saves the created company and answers its create with the model; an answer of another project is answered, not stored. */
export const broadcastCreatedCompany = async (
  companyInDto: CompanyInDto,
  uniqueId: string,
  projectId?: string
): Promise<void> => {
  try {
    const isStored = await scopeOfProject(projectId).write(async () => {
      await dbCompanies.addBatch([companyInDto]);
      return true;
    });
    // An answer of a project no longer selected is not stored, but still answered from the server's company.
    const companyEntity = isStored ? await dbCompanies.getOne(companyInDto._id) : companyInDtoToEntity(companyInDto);
    if (!companyEntity) {
      throw new Error(`Cannot find company with id ${companyInDto._id}`);
    }
    const users = await getUsersSynchronized();
    broadcastCreatedCompanyModel(companyEntityToModel(companyEntity, users), uniqueId);
  } catch (error) {
    broadcastUploadedCompanyError(error, chooseErrorMessage(error), uniqueId);
  }
};
